<template>
  <div class="mt-5 b-white">
    <div class="py-5 b-gray-light">
      <div class="col-lg-12 text-center">
        <h1 class="fas fa-credit-card font-blue"></h1>
        <h4 class="font-gray-dark">Adquirir Membresía</h4>
      </div>
    </div>
    <div class="container py-5">
      <b-breadcrumb :items="items" class="bg-transparent p-0"></b-breadcrumb>
      <div class="row">
        <div class="col-lg-12 text-center p-3" v-show="downloading">
          <b-spinner small label="Espere ..."></b-spinner>
          <br>
          <small>Espere un momento...</small>
        </div>
      </div>
      <div class="row" v-if="!downloading && !response.isNowPlan">
        <div class="col-lg-6">
          <h3 class="font-weight-light">Detalle de tu compra</h3>
          <table class="table table-striped mt-4">
            <tbody>
            <tr>
              <td>Producto:</td>
              <td>Membresía {{ response.plan_info.plan }} / {{ response.plan_info.name }}</td>
            </tr>
            <tr>
              <td>Detalles:</td>
              <td>Incluye {{ response.plan_info.candidates }} Candidatos</td>
            </tr>
            <!-- <tr>
              <td>Subtotal:</td>
              <td>$ {{ (response.plan_info.cost - (response.plan_info.cost * 0.16)) }}
                {{ response.plan_info.currency }}
              </td>
            </tr>
            <tr>
              <td>IVA:</td>
              <td>$ {{  response.plan_info.cost * 0.16 }}   {{ response.plan_info.currency }}
              </td>
            </tr> -->
            <tr>
              <td>Total:</td>
              <td>$ {{ response.plan_info.cost }} {{ response.plan_info.currency }} <em>(IVA incluido)</em></td>
            </tr>
            </tbody>
          </table>
          <hr>

        </div>
        <div class="col-lg-6">
          <h3 class="font-weight-light">Selecciona tu forma de pago</h3>
          <hr>
          <b-button block v-b-toggle.accordion-1 variant="light"  size="lg" style="background:#143069; color:#fff;">Tarjeta débito/crédito</b-button> 
          <b-collapse id="accordion-1"  accordion="my-accordion" role="tabpanel" class="mt-3"> 
            <hr>
            <center> 
              <template v-if="pagado == 0"> 
                  <CreditCard :pay_id="pay_id" :plan_id="response.plan_info.id"
                            :cost="response.plan_info.cost" :currency="response.plan_info.currency"
                            :bill-required="billRequired" :bill-data="billData" :plan="'Membresía ' + response.plan_info.plan + ' / ' + response.plan_info.name" :valida="'Si'"/>
              </template>
              <template v-else>
                  <h4 style="color:#28a745;">¡Gracias!</h4>
                  <p style="color:#28a745;">Tu pago se ha realizado con éxito.</p> 
                  <div class="mt-2">
                    <b-form-checkbox
                        v-model="billRequired"
                        :value="true"
                        :unchecked-value="false"
                        @change="abrirMod()">
                      Requiero factura para esta compra 
                    </b-form-checkbox>
                  </div>
                  <div class="mt-3" v-if="billRequired">
                    <h3 class="font-weight-light">Datos de facturación</h3>
                    <p>Por favor llena o confirma tus datos fiscales para poder generar tu factura</p>
                    <div class="mt-3">
                      <b-form-input type="text" class="mt-3"
                                    placeholder="*RFC"
                                    :state="billDataValidate.rfc"
                                    v-model="billData.rfc"/>
                        <p class="text-danger text-left" style="font-size:small;" v-if="errors.includes( 'rfc' )">
                            Campo requerido
                        </p>
                      <b-form-input type="text" v-model="billData.razonSocial" class="mt-3"
                                    placeholder="*Razón social"
                                    :state="billDataValidate.razonSocial"/>
                        <p class="text-danger text-left" style="font-size:small;" v-if="errors.includes( 'razon' )">
                            Campo requerido
                        </p>
                      <b-form-input type="text" class="mt-3"
                                    placeholder="Calle"
                                    :state="billDataValidate.domicilioFiscal"
                                    v-model="billData.domicilioFiscal"/>
                        <p class="text-danger text-left" style="font-size:small;" v-if="errors.includes( 'calle' )">
                            Campo requerido
                        </p>
                      <div class="row justify-content-center">
                        <div class="col-4">
                          <b-form-input type="text" class="mt-3"
                                    placeholder="Número exterior"
                                    :state="billDataValidate.numero_ext"
                                    v-model="billData.numero_ext"/>
                        </div>
                        <div class="col-4">
                          <b-form-input type="text" class="mt-3"
                                    placeholder="Número interior"
                                    :state="billDataValidate.numero_int"
                                    v-model="billData.numero_int"/>
                        </div>
                        <div class="col-4">
                          <b-form-input type="text" class="mt-3"
                                    placeholder="*Código postal"
                                    :state="billDataValidate.codigo_postal"
                                    v-model="billData.codigo_postal"/>
                          <p class="text-danger text-left" style="font-size:small;" v-if="errors.includes( 'cp' )">
                            Campo requerido
                          </p>
                        </div>
                      </div>
                      <b-form-input type="email" class="mt-3"  :state="billDataValidate.email"
                                    placeholder="*Correo electrónico"
                                    v-model="billData.email"/>
                        <p class="text-danger text-left" style="font-size:small;" v-if="errors.includes( 'email' )">
                            Campo requerido
                        </p>
                      <b-select class="form-control mt-3"  :state="billDataValidate.regimen"  v-model="billData.regimen">
                        <option value="">*Seleccionar Régimen fiscal</option>
                        <option value="601">601 - General de Ley Personas Morales.</option>
                        <option value="603">603 - Personas Morales con Fines no Lucrativos.</option> 
                        <option value="612">612 - Personas Físicas con Actividades Empresariales y Profesionales.</option>  
                        <option value="616">616 - Sin obligaciones fiscales.</option>  
                      </b-select>
                        <p class="text-danger text-left" style="font-size:small;" v-if="errors.includes( 'regimen' )">
                            Campo requerido
                        </p>
                      <b-select class="form-control mt-3" :state="billDataValidate.usoCfdi" v-model="billData.usoCfdi">
                        <option value="">*Seleccionar uso de CFDI</option> 
                        <option value="G03">G03 - Gastos en general</option> 
                        <option value="S01">S01 - Sin efectos fiscales</option>
                      </b-select>
                        <p class="text-danger text-left" style="font-size:small;" v-if="errors.includes( 'usocfdi' )">
                            Campo requerido
                        </p>
                      <b-select class="form-control mt-3"  :state="billDataValidate.pago" v-model="billData.pago">
                        <option value="">*Seleccionar método de pago</option> 
                        <!-- <option value="01">01 - Efectivo.</option> 
                        <option value="02">02 - Cheque nominativo.</option> 
                        <option value="03">03 - Transferencia electrónica de fondos.</option>  -->
                        <option value="04">04 - Tarjeta de crédito.</option> 
                        <option value="28">28 - Tarjeta de débito.</option>   
                      </b-select>
                        <p class="text-danger text-left" style="font-size:small;" v-if="errors.includes( 'pago' )">
                            Campo requerido
                        </p>
                    </div>
                  </div>
                  <template v-if="billRequired">
                      <button  class="mt-3 btn btn-block  shadow-sm b-green" @click="facturar()" :disabled="loading == true">
                          <b-spinner v-if="loading" small label="Espere ..."></b-spinner> Enviar 
                      </button> 
                  </template>
                  <template v-else>
                    <button  class="mt-3 btn btn-block  shadow-sm b-green" @click="recargar()" >
                          <b-spinner v-if="loading" small label="Espere ..."></b-spinner> OK 
                      </button> 
                  </template>
              </template>
            </center>
          </b-collapse>

          <b-button block v-b-toggle.accordion-2 variant="light" class="mt-3"  size="lg" style="background:#0333a9; color:#fff;">PayPal</b-button> 
          <b-collapse id="accordion-2"  accordion="my-accordion" role="tabpanel" class="mt-3"> 
            <hr>
              <center> 
                <template v-if="pagado2 == 0"> 
                    <CheckoutPayment 
                      :pay_id="response.plan_info.id"
                      :cost="response.plan_info.cost"
                      :bill-required="billRequired"
                      :bill-data="billData" 
                      :plan="'Membresía ' + response.plan_info.plan + ' / ' + response.plan_info.name"
                    ></CheckoutPayment>
                </template>
                <template v-else>
                    <h4 style="color:#28a745;">¡Gracias!</h4>
                    <p style="color:#28a745;">Tu pago se ha realizado con éxito.</p>
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="billRequired"
                          :value="true"
                          :unchecked-value="false"
                          @change="abrirMod()">
                        Requiero factura para esta compra 
                      </b-form-checkbox>
                    </div>
                    <div class="mt-3" v-if="billRequired">
                    <h3 class="font-weight-light">Datos de facturación</h3>
                    <p>Por favor llena o confirma tus datos fiscales para poder generar tu factura</p>
                    <div class="mt-3">
                      <b-form-input type="text" class="mt-3"
                                    placeholder="*RFC"
                                    :state="billDataValidate.rfc"
                                    v-model="billData.rfc"/>
                        <p class="text-danger text-left" style="font-size:small;" v-if="errors.includes( 'rfc' )">
                            Campo requerido
                        </p>
                      <b-form-input type="text" v-model="billData.razonSocial" class="mt-3"
                                    placeholder="*Razón social"
                                    :state="billDataValidate.razonSocial"/>
                        <p class="text-danger text-left" style="font-size:small;" v-if="errors.includes( 'razon' )">
                            Campo requerido
                        </p>
                      <b-form-input type="text" class="mt-3"
                                    placeholder="Calle"
                                    :state="billDataValidate.domicilioFiscal"
                                    v-model="billData.domicilioFiscal"/>
                        <p class="text-danger text-left" style="font-size:small;" v-if="errors.includes( 'calle' )">
                            Campo requerido
                        </p>
                      <div class="row justify-content-center">
                        <div class="col-4">
                          <b-form-input type="text" class="mt-3"
                                    placeholder="Número exterior"
                                    :state="billDataValidate.numero_ext"
                                    v-model="billData.numero_ext"/>
                        </div>
                        <div class="col-4">
                          <b-form-input type="text" class="mt-3"
                                    placeholder="Número interior"
                                    :state="billDataValidate.numero_int"
                                    v-model="billData.numero_int"/>
                        </div>
                        <div class="col-4">
                          <b-form-input type="text" class="mt-3"
                                    placeholder="*Código postal"
                                    :state="billDataValidate.codigo_postal"
                                    v-model="billData.codigo_postal"/>
                          <p class="text-danger text-left" style="font-size:small;" v-if="errors.includes( 'cp' )">
                            Campo requerido
                          </p>
                        </div>
                      </div>
                      <b-form-input type="email" class="mt-3"  :state="billDataValidate.email"
                                    placeholder="*Correo electrónico"
                                    v-model="billData.email"/>
                        <p class="text-danger text-left" style="font-size:small;" v-if="errors.includes( 'email' )">
                            Campo requerido
                        </p>
                      <b-select class="form-control mt-3"  :state="billDataValidate.regimen"  v-model="billData.regimen">
                        <option value="">*Seleccionar Régimen fiscal</option>
                        <option value="601">601 - General de Ley Personas Morales.</option>
                        <option value="603">603 - Personas Morales con Fines no Lucrativos.</option> 
                        <option value="612">612 - Personas Físicas con Actividades Empresariales y Profesionales.</option>  
                        <option value="616">616 - Sin obligaciones fiscales.</option>  
                      </b-select>
                        <p class="text-danger text-left" style="font-size:small;" v-if="errors.includes( 'regimen' )">
                            Campo requerido
                        </p>
                      <b-select class="form-control mt-3" :state="billDataValidate.usoCfdi" v-model="billData.usoCfdi">
                        <option value="">*Seleccionar uso de CFDI</option> 
                        <option value="G03">G03 - Gastos en general</option> 
                        <option value="S01">S01 - Sin efectos fiscales</option>
                      </b-select>
                        <p class="text-danger text-left" style="font-size:small;" v-if="errors.includes( 'usocfdi' )">
                            Campo requerido
                        </p>
                      <b-select class="form-control mt-3"  :state="billDataValidate.pago" v-model="billData.pago">
                        <option value="">*Seleccionar método de pago</option> 
                        <!-- <option value="01">01 - Efectivo.</option> 
                        <option value="02">02 - Cheque nominativo.</option> 
                        <option value="03">03 - Transferencia electrónica de fondos.</option>  -->
                        <option value="04">04 - Tarjeta de crédito.</option> 
                        <option value="28">28 - Tarjeta de débito.</option>   
                      </b-select>
                        <p class="text-danger text-left" style="font-size:small;" v-if="errors.includes( 'pago' )">
                            Campo requerido
                        </p>
                    </div>
                    </div>
                    <template v-if="billRequired">
                        <button  class="mt-3 btn btn-block  shadow-sm b-green" @click="facturar()" :disabled="loading == true">
                           <b-spinner v-if="loading" small label="Espere ..."></b-spinner> Enviar 
                        </button> 
                    </template>
                    <template v-else>
                      <button  class="mt-3 btn btn-block  shadow-sm b-green" @click="recargar()" >
                           <b-spinner v-if="loading" small label="Espere ..."></b-spinner> OK 
                        </button> 
                    </template>
                  
                </template>
              </center>
            <hr>
          </b-collapse>

          <b-button block v-b-toggle.accordion-3 variant="light" class="mt-3"  size="lg" style="background:#005aff; color:#fff;">Pagos con cheque, en efectivo o transferencia</b-button> 
          <b-collapse id="accordion-3"  accordion="my-accordion" role="tabpanel" class="mt-3"> 
            <template v-if="pagado3 == 0">
              <hr>
              <p class="text-center" style="font-size: small;">Selecciona la cuenta del banco de tu preferencia para realizar el pago de tu membresía.</p>
                <table class="table mt-4">
                      <thead>
                        <tr>
                          <th scope="col" style="font-size: small;"># de cuenta</th>
                          <th scope="col" style="font-size: small;">Clabe int</th>
                          <th scope="col" style="font-size: small;">Titular de cuenta</th>
                          <th scope="col" style="font-size: small;">Banco</th>
                        </tr>
                      </thead>
                      <tbody>
                          <tr v-for="ban in bancos" :key="ban.id">
                              <td>{{ban.number_account}}</td>
                              <td>{{ban.clabe}}</td> 
                              <td>{{ban.owner}}</td> 
                              <td>{{ban.bank}}</td>  
                          </tr> 
                      </tbody>
                  </table>
                <hr>
                  <center>
                    <h5>
                      Pagar $ {{response.plan_info.cost}} MXN
                    </h5>
                    <hr>
                    <b style="color:#143069; font-size: small;">
                      Después de realizar tu pago, por favor, envía tu comprobante aquí, <br> una vez que hayamos validado el registro de tu pago en cuenta, se activará tu membresía 
                    </b>
                  </center>
                  <b-form @submit="this.onSubmit" class="mt-3">
                    <div class="row justify-content-center">
                      <div class="col-md-8">
                        <label class="d-block bh-cursor border-1 border-dashed p-4 border-gray-dark text-center font-gray-dark">
                          <i class="fas fa-paperclip" v-show="!form.file"></i>
                          <i class="fas fa-check-circle" v-show="form.file"></i>
                          {{form.file ? form.file.name : 'Adjuntar documento '}}
                          <input type="file" @change="handleFileUpload" hidden>
                          <b-form-invalid-feedback :state="false" v-if="this.errors.file">
                            Campo requerido
                          </b-form-invalid-feedback>
                        </label> 
                      </div>
                      <div class="col-md-12"></div>
                      <div class="col-md-4">
                        <b-button type="submit" class="b-orange col-md-12  mt-4" :disabled="loading">
                          <b-spinner v-if="loading" small label="Espere ..."></b-spinner>
                          Enviar
                        </b-button>
                      </div>
                    </div>
                  </b-form>
            </template>
            <template v-else>
            <hr>
              <center>
                  <h4 style="color:#28a745;">¡Gracias!</h4>
                  <p style="color:#28a745;">Comprobante enviado exitosamente, <br> recibirás un correo, confirmando la activación de tu membresía.</p>
                  <br>
                  <button  class="btn btn-block  shadow-sm b-green" @click="recargar()">
                    <span>OK</span>
                  </button>
              </center>
            </template>
            <hr> 
          </b-collapse>


        </div>
      </div>

      <b-modal id="demo_fact" title="Aviso"  hide-footer   hide-header  size="lg" >  
        <div class="row justify-content-center" style="cursor: pointer;" @click="cerrarMod()">
          <div class="col-12">
          <div class="text-center">
            <center>
              <b-img style="width: auto; height: auto; background-color: #FFF; z-index: 1;" src="https://dev.kllaar.com/static/doct_factura3.jpg"  fluid-grow  alt="Responsive image"></b-img>
            </center> 
           </div>
          </div>  
        </div> 
      </b-modal> 

      <div v-if="!downloading && response.isNowPlan">
        <isNowPlan :planUser="response.user_plan"/>
      </div>
    </div>
  </div>
</template>
<script>
import isNowPlan from './components/isNowPlan'
import CheckoutPayment from '../payments/CheckoutPayment2.vue'
import axios from 'axios'
export default {
  components: {
    'isNowPlan': isNowPlan,
    CheckoutPayment
  },
  data() {
    return {
      pay_id: new Date().valueOf(),
      items: [
        {
          text: "Membresías",
          href: "/memberships"
        },
        {
          text: "",
          actiove: true
        },
      ],
      response: [],
      downloading: false,
      errors: [],
      billRequired: false,
      billData: {
        razonSocial: "",
        rfc: "", 
        domicilioFiscal: "",
        email: "",
        usoCfdi: "",
        numero_ext:"",
        numero_int:"",
        codigo_postal:"",
        regimen:"",
        pago:""
      },
      billDataValidate: {
        razonSocial: null,
        rfc: null,
        domicilioFiscal: null,
        email: null,
        usoCfdi: null,
      },
      pagado:0,
      pagado2:0,
      pagado3:0,
      factura:{},
      bancos:[],
      form: { 
        file: ''
      },
      loading:false,
      mensaje:""
    }
  },
  watch: {
    planInfo: function (value) {
      this.form.value = value.cost
    }
  },
  methods: {
    onSubmit(evt) { 
      evt.preventDefault()
        let fd = new FormData()
        this.loading = true 
        fd.append('file', this.form.file)
        fd.append('plan_id', this.response.plan_info.id)

        if (this.form.file === '') {
          this.errors.file = {};
          this.loading = false
          return false;
        }

        this.api.post('course/payment-efectivo2', fd).then(({data}) => { 
          this.loading = false 
          this.form = { 
            file: ''
          }; 
          this.pagado3 = 1;
        }).catch(err => {
          this.loading = false
          if (err.response.status == 422) {
            this.errors = err.response.data.errors
          }
        })
    },
    handleFileUpload(e) {
      this.form.file = e.target.files[0]
    },
    bancoKllaar(){
      this.api.get('trainer/bancokllaar').then( ({data}) => {
                this.loader = false;
                if (data.bank_data) {
                    this.bancos = data.bank_data;
                } 
                
            }).catch(err => {
                console.log(err)
            }) 
    },
    abrirMod(){
      if (this.billRequired == true)
      {
        this.$bvModal.show('demo_fact'); 
        this.api.get('member/factura').then(({data}) => { 
          this.factura = JSON.parse(data.fact);
          if (this.factura ) {
            this.billData.domicilioFiscal = this.factura.domicilioFiscal;
            this.billData.email = this.factura.email;
            this.billData.razonSocial = this.factura.razonSocial;
            this.billData.rfc = this.factura.rfc;
            this.billData.usoCfdi = this.factura.usoCfdi;
            this.billData.pago = this.factura.pago;
            this.billData.regimen = this.factura.regimen;
            this.billData.codigo_postal = this.factura.codigo_postal;
            this.billData.numero_int = this.factura.numero_int;
            this.billData.numero_ext = this.factura.numero_ext;
          }
        })
      } 
    },
    cerrarMod(){
      this.$bvModal.hide('demo_fact'); 
    },
    recargar(){
         location.href = "https://dev.kllaar.com/perfil/membresia";
    },
    onSubmitPay() {
      let paymentForm = {
        plan_id: this.planInfo.id,
        payment_platform: this.form.payment_platform,
        payment_platform_function: this.form.payment_platform_function,
        token_id: this.conektaTokenGenerate
      }

      this.api.post('conekta/pay', JSON.stringify(paymentForm)).then(({data}) => {
        this.getIsMember()

        this.loadingPayment = false
        this.toast(data.message)

      }).catch(err => {
        this.loadingPayment = false
        if (err.response.status == 422) {
          this.errors = err.response.data.errors
        }
      })
    },
    paymentSelection(payment) {
      this.form.payment_platform = payment.id
      this.form.payment_platform_function = payment.function
    },
    toast(message) {
      this.$bvToast.toast(message, {
        title: "Kllaar.com",
        variant: 'success',
        toaster: 'b-toaster-bottom-right',
        solid: true,
        appendToast: true
      })
    },
    membershipEnterprise(query) {
      this.downloading = true
      this.api.get('member/payment_plan?id=' + query).then(({data}) => {
        this.response = data
        this.items[1].text = data.plan_info.plan + ' - ' + data.plan_info.name
        this.downloading = false
      }).catch(err => {
        this.$router.push('/memberships')
      })
    },
    addMembers(query) {
      this.downloading = true
      this.api.get('member/payment_extra').then(({data}) => {
        console.log(data)
      }).catch(err => {
        this.downloading = false
      })
    },
    setInvoiceDataForm(data) {
      this.billData.email = data.email
      this.billData.rfc = data.rfc
      this.billData.razonSocial = data.name
    },
    validateFormInvoice() {
      let rfc = true;
      this.billDataValidate.rfc = null
      if (!this.billData.rfc.trim()) {
        this.billDataValidate.rfc = false
        rfc = false
      }

      let email = true;
      if (!this.billData.email.trim()) {
        this.billDataValidate.email = false
        email = false
      }

      let domicilio = true;
      this.billDataValidate.domicilioFiscal = null
      if (!this.billData.domicilioFiscal.trim()) {
        this.billDataValidate.domicilioFiscal = false
        domicilio = false
      }

      let razon = true;
      this.billDataValidate.razonSocial = null
      if (!this.billData.razonSocial.trim()) {
        this.billDataValidate.razonSocial = false
        razon = false
      }

      let uso = true;
      this.billDataValidate.uso = false
      if (!this.billData.usoCfdi.trim()) {
        this.billDataValidate.usoCfdi = false
        uso = false
      }

      return rfc && email && domicilio && uso && razon;
    },
    crearFactura(){
      this.mensaje = "";

      const token = 'sk_test_b6X4Y5QELJjyzeKDAPo9jjQ986MP2ONa1pnmlR7vWV'; 

      const  headers = {  
              'Authorization': `Bearer ${token}` 
          }

      var objprueba = null;

      objprueba = {
            "payment_form": this.billData.pago,
            "use": this.billData.usoCfdi,
            "customer": {
              "legal_name": this.billData.razonSocial,
              "tax_id": this.billData.rfc,
              "tax_system": this.billData.regimen,
              "email": this.billData.email,
              "address": {
                "street": this.billData.domicilioFiscal,
                "zip":this.billData.codigo_postal,
                "country": "MEX",
                "interior":this.billData.numero_int,
                "exterior":this.billData.numero_ext
              }
            },
            "items": [
              { 
                "product": {
                  "description": 'Membresía ' + this.response.plan_info.plan + ' / ' + this.response.plan_info.name,
                  "price": this.response.plan_info.cost,
                  "product_key":"90111800",
                  "unit_key": "DAY"
                }
              }
            ]
          }
      axios.post('https://www.facturapi.io/v2/invoices',  objprueba, {
        headers: headers
      }).then( ({data}) => { 
        // if (data.response.status === 400) {
        //   console.log("ahora si");
        // }
            console.log(data);
            this.enviarFactura(data.id);
      }).catch( error => {
        if (error.response) {
          console.log('Server responded with status code:', error.response.status);
          console.log('Response data:', error.response.data.message);
          // swal("Error", error.response.data.message, "error") 
          
          this.errorToast(error.response.data.message);
        } else if (error.request) {
          console.log('No response received:', error.request);
        } else {
          console.log('Error creating request:', error.message);
        }
      });
    },
    enviarFactura(id){
      const token = 'sk_test_b6X4Y5QELJjyzeKDAPo9jjQ986MP2ONa1pnmlR7vWV'; 

      const  headers = {  
              'Authorization': `Bearer ${token}` 
          }

          var objprueba = null;

      axios.post('https://www.facturapi.io/v2/invoices/' + id + '/email',objprueba, {
        headers: headers
      }).then( ({data}) => { 
        this.loading = false;
            console.log(data); 
            this.$router.push('/perfil/membresia');
      }); 
    },
    facturar(){
      this.errors = [];

        if (!this.billData.rfc)
        {
            this.errors.push('rfc');  
        }if (!this.billData.razonSocial)
        {
            this.errors.push('razon');  
        }if (!this.billData.domicilioFiscal)
        {
            this.errors.push('calle');  
        }if (!this.billData.codigo_postal)
        {
            this.errors.push('cp');  
        }if (!this.billData.email)
        {
            this.errors.push('email');  
        }if (!this.billData.regimen)
        {
            this.errors.push('regimen');  
        }if (!this.billData.usoCfdi)
        {
            this.errors.push('usocfdi');  
        }if (!this.billData.pago)
        {
            this.errors.push('pago');  
        }if (this.errors.length == 0) { 
            var paymentForm = null;

            paymentForm = {
                invoiceRequired: this.billRequired,
                invoiceData: this.billData, 
                type: "plan", 
                idItem: this.$route.query.plan_id 
              };

              this.loading = true;

            this.api.post("payment/generaFactura", JSON.stringify(paymentForm))
              .then(({data}) => {
                console.log(data);
                
                
                if (this.billRequired == true)
                {
                  this.crearFactura();
                } 
              })
      }
    },
    errorToast(id){
      var mns = "";
      switch (id) {
        case 'El campo "tax_id" es obligatorio y debe ser un RFC válido':
          mns = 'El campo RFC es obligatorio y debe ser un dato válido'          
        break; 
        case '"customer.email" must be a valid email':
          mns = 'El campo email es obligatorio y debe ser un dato válido'          
        break; 
        default:
          mns = id;
        break;
      } 
      this.loading = false;
      this.$bvToast.toast(mns, {
                title: "Kllaar.com",
                variant: 'danger',
                toaster: 'b-toaster-bottom-right',
                solid: true,
                appendToast: true
              })
    }

  },
  created() {
    let plan = this.$route.query.plan_id
    this.membershipEnterprise(plan)

    this.api.get('enterprise/info/userinfo').then(({data}) => {
      this.setInvoiceDataForm(data.enterprise_info)
    })

    this.bus.$on("payment_" + this.pay_id, (result) => {
      // this.$router.push('/perfil/membresia')
      this.pagado = 1; 
    });

    this.bus.$on("validate_billdata", () => {
      let isValid = this.validateFormInvoice()
      this.$bus.$emit('validate_billdata_resp', isValid)
    });

    
    
    // this.bus.$on("payment_paypal", () => {
    //       // this.$router.back();
    //       this.pagado = 1; 
    //   });
      
      this.bus.$on("payment_paypal2", () => {
          // this.$router.back();
          this.pagado2 = 1;
          // if (this.billRequired == true)
          // {
          //   this.crearFactura();
          // }
      });

  },
  mounted(){
    this.bancoKllaar();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/#public/member/MemberPayment.vue